import { Balance } from "./../components/Balance";
import { Form } from "./../components/Form";
import { Transactions } from "./../components/Transactions";

export const Home = () => {
    return (
        <>
            <Balance />
            <Form />
            <Transactions />
        </>
    );
};
